module.exports = __webpack_public_path__ + "static/media/Anchoring Effect - sophie-walker-3NjBnYmbsDg-unsplash.b8c1d863.jpg";